var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kft-step"},[(_vm.active)?_vm._t("default",null,{"index":_vm.index}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }